export default __webpack_public_path__ + "static/media/edit.6b129a1c.svg";